<ng-template #contentTpl>
  <ng-content />
</ng-template>

@if (isOpen()) { @if (isMobile()) {
<div #mobilePortal>
  <div
    class="fixed inset-0 bg-black/40 backdrop-blur-sm"
    style="z-index: 1000"
    role="button"
    tabindex="-1"
    aria-label="Close panel"
    (click)="close()"
  ></div>

  <div [class]="panelClass()" style="z-index: 1001">
    <div
      class="flex justify-center pt-3 pb-1 w-full shrink-0 cursor-pointer"
      role="button"
      tabindex="0"
      aria-label="Close"
      (click)="close()"
      (keydown.enter)="close()"
      (keydown.space)="close()"
    >
      <div class="w-10 h-1 rounded-full bg-slate-300 dark:bg-white/20"></div>
    </div>

    <div class="pb-6">
      <ng-container [ngTemplateOutlet]="contentTpl" />
    </div>
  </div>
</div>
} @else {
<div
  class="fixed inset-0"
  style="z-index: 40"
  role="button"
  tabindex="-1"
  (click)="close()"
></div>

<div [class]="panelClass()" style="z-index: 50">
  <ng-container [ngTemplateOutlet]="contentTpl" />
</div>
} }
